let noticeShown = false;

function renderNotice() {
  const dialog = document.createElement('dialog');
  dialog.className = 'fanbird-limit-dialog';
  dialog.setAttribute('aria-labelledby', 'fanbird-limit-title');
  dialog.innerHTML = `
    <div class="fanbird-limit-brand"><img src="/Logo.png" alt=""><span>FanBird</span></div>
    <div class="fanbird-limit-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none"><path d="M12 3 20 6v5c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-3Z"/><path d="M12 8v4m0 3h.01"/></svg>
    </div>
    <h1 id="fanbird-limit-title">잠시 이용이 제한되었습니다</h1>
    <p>서비스를 보호하기 위해 요청을 잠시 멈췄습니다.</p>
    <div class="fanbird-limit-detail">짧은 시간 동안 요청이 반복되어<br><strong>1시간 동안 일부 기능 이용이 제한됩니다.</strong><br>잠시 후 다시 이용해 주세요.</div>
    <button class="fanbird-limit-home" type="button">확인</button>
  `;

  const style = document.createElement('style');
  style.id = 'fanbird-limit-styles';
  style.textContent = `
    .fanbird-limit-dialog{width:min(440px,calc(100vw - 32px));max-height:calc(100dvh - 24px);overflow:auto;box-sizing:border-box;border:0;border-radius:24px;padding:34px 32px 28px;color:#201b37;background:#fff;font-family:Pretendard-Medium,Pretendard,sans-serif;text-align:center;box-shadow:0 24px 80px #17112e40}
    .fanbird-limit-dialog::backdrop{background:#17112e99;backdrop-filter:blur(5px)}
    .fanbird-limit-brand{display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:28px;color:#3930a8;font:700 17px Pretendard-Bold,Pretendard,sans-serif;letter-spacing:-.03em}
    .fanbird-limit-brand img{width:30px;height:30px;object-fit:contain}
    .fanbird-limit-icon{display:grid;place-items:center;width:64px;height:64px;margin:0 auto 21px;border-radius:20px;background:#f1efff;color:#5948dc}
    .fanbird-limit-icon svg{width:31px;height:31px;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}
    .fanbird-limit-dialog h1{margin:0;color:#201b37;font:700 23px/1.35 Pretendard-Bold,Pretendard,sans-serif;letter-spacing:-.04em;word-break:keep-all}
    .fanbird-limit-dialog p{margin:10px 0 0;color:#625d73;font-size:15px;line-height:1.6;word-break:keep-all}
    .fanbird-limit-detail{margin:23px 0 25px;padding:17px 12px;border-radius:14px;background:#f7f6fc;color:#625d73;font-size:14px;line-height:1.8;word-break:keep-all}
    .fanbird-limit-detail strong{color:#3930a8;font-family:Pretendard-SemiBold,Pretendard,sans-serif;font-weight:600}
    .fanbird-limit-home{width:100%;min-height:50px;border:0;border-radius:12px;background:#5142d8;color:#fff;font:600 16px Pretendard-SemiBold,Pretendard,sans-serif;cursor:pointer;transition:background .18s ease,transform .18s ease}
    .fanbird-limit-home:hover{background:#4032bf;transform:translateY(-1px)}
    .fanbird-limit-home:focus-visible{outline:3px solid #aaa1ff;outline-offset:3px}
    @media(max-width:480px){.fanbird-limit-dialog{padding:28px 22px 22px;border-radius:20px}.fanbird-limit-brand{margin-bottom:24px}.fanbird-limit-dialog h1{font-size:21px}}
    @media(prefers-reduced-motion:reduce){.fanbird-limit-home{transition:none}}
  `;
  document.head.append(style);
  document.body.append(dialog);
  const close = () => dialog.close();
  dialog.querySelector('button')?.addEventListener('click', close);
  dialog.addEventListener('close', () => { noticeShown = false; style.remove(); dialog.remove(); });
  dialog.showModal();
}

export function showIpBanNotice(error: unknown) {
  const code = (error as { response?: { data?: { code?: string } } })?.response?.data?.code;
  if (code !== 'IP_RATE_BANNED') return;

  if (!noticeShown) {
    noticeShown = true;
    renderNotice();
  }
}
